// generates a 6-character random id
// taken from https://github.com/jossmac/react-toast-notifications/blob/master/src/utils.js
export function uniqueId() {
  var first = Math.random() * 46656 | 0;
  var second = Math.random() * 46656 | 0;
  first = ('000' + first.toString(36)).slice(-3);
  second = ('000' + second.toString(36)).slice(-3);
  return first + second;
}